import { ProjectsHeaderProps } from "./ProjectsHeader.types";

export const ProjectsHeader = ({ subtitle }: ProjectsHeaderProps) => (
  <header className="flex flex-col gap-1">
    <h1 className="font-squada text-4xl uppercase leading-none text-foreground">Projects</h1>
    {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
  </header>
);
